import { Printer, Share2 } from 'lucide-react'
import { Brand } from './Brand'
import { DisplayControls } from './DisplayControls'
import { useI18n } from '../core/i18n'

export function PublicHeader({ onShare }: { onShare?: () => void }) {
  const { tr } = useI18n()
  return (
    <header className="public-header glass-bar">
      <Brand />
      <div className="header-actions">
        <button className="icon-button desktop-action" onClick={() => window.print()} aria-label={tr.print}><Printer size={18} /></button>
        {onShare && <button className="icon-button desktop-action" onClick={onShare} aria-label={tr.share}><Share2 size={18} /></button>}
        <DisplayControls />
      </div>
    </header>
  )
}
